import _sdk from '@hopdrive/sdk';
import { init as _initLanesSDK } from '@hopdrive/sdk-lanes';
import { init as _initEventsSDK } from '@hopdrive/sdk-events';
import { init as _initOutcomesSDK } from '@hopdrive/sdk-outcomes';

export { _sdk };

/**
 * Build a GqlExecutor from an Apollo Client instance.
 * The returned object satisfies the { query, mutate } interface
 * expected by all @hopdrive/sdk-* packages.
 */
export function createApolloExecutor(apolloClient) {
  return {
    query: async (document, variables) => {
      const result = await apolloClient.query({ query: document, variables, fetchPolicy: 'network-only' });
      return result.data;
    },
    mutate: async (document, variables) => {
      const result = await apolloClient.mutate({ mutation: document, variables });
      return result.data;
    },
  };
}

export function initSDK(apolloClient) {
  _sdk.configure({ apollo_client: apolloClient });
}

export function initLanes({ executor, googleApiKey }) {
  _initLanesSDK({ executor, googleApiKey });
}

export function initEvents({ executor }) {
  _initEventsSDK({ executor });
}

export function initOutcomes({ executor }) {
  _initOutcomesSDK({ executor });
}

/**
 * Initialize all HopDrive SDKs with a single Apollo Client.
 * Each SDK package maintains its own sdk-core singleton, so we
 * must call init on each one individually.
 */
export function initUniversalSDK({ apolloClient, googleApiKey }) {
  const executor = createApolloExecutor(apolloClient);
  initSDK(apolloClient);
  initLanes({ executor, googleApiKey });
  initEvents({ executor });
  initOutcomes({ executor });
}
